import {
  Block,
  BlockFooter,
  Button,
  Icon,
  List,
  ListItem,
} from "framework7-react";
import { ASSIGN_HINT } from "../assign-me/assign-prompt";

const AssignStep = ({
  participants,
  selectedId,
  disabled,
  onAssign,
  onSkip,
}) => (
  <Block className="create-group-assign">
    <List strong dividersIos>
      {participants.map((participant) => (
        <ListItem
          key={participant.id}
          title={participant.name}
          link
          onClick={() => onAssign(participant.id)}
        >
          {participant.id === selectedId && (
            <Icon md="material:check" ios="f7:checkmark" slot="media" />
          )}
        </ListItem>
      ))}
    </List>
    {selectedId !== null && (
      <Button
        fill
        className="create-group-assign-done"
        disabled={disabled}
        onClick={() => onAssign(selectedId)}
      >
        Fertig
      </Button>
    )}
    <Button
      tonal
      className="create-group-assign-skip margin-top"
      disabled={disabled}
      onClick={onSkip}
    >
      Überspringen
    </Button>
    <BlockFooter className="assign-me-hint">{ASSIGN_HINT}</BlockFooter>
  </Block>
);

export default AssignStep;
